<template>
  <div class="tile">
    <MarketReportsMenu  :isEditable="isEditable"
                        :header="header"
                        @edit="handleEdit"
                        @undo="handleUndo"
                        @save="handleSave" />
    <div class="tile-container">
      <div  class="tile-content"
            v-if="data && data.length > 0">
        <DxChart  id="chart"
                  :data-source="data"
                  :customize-label="customizeLabel"
                  overlapping-behavior="none"
                  @pointClick="onPointClick">

          <DxCommonSeriesSettings argument-field="xNumber"
                                  type="bar"
                                  hover-mode="none"
                                  overlapping-behavior="none"
                                  selection-mode="none">
            <DxLabel :visible="true" overlappingBehavior="none">
              <DxFormat :precision="0"
                        type="fixedPoint" />
            </DxLabel>
          </DxCommonSeriesSettings>

          <DxArgumentAxis :staggered="true"
                          overlapping-behavior="none"
                          word-wrap="none"
                          :label="{ overlappingBehavior: 'none', customizeText: customizeText }">
            <DxConstantLine :value="constantLinePosition"
                            :width="2"
                            color="gray"
                            overlapping-behavior="none"
                            displayBehindSeries="false"
                            dash-style="solid"
                            :paddingTopBottom="-10"
                            :paddingLeftRight="100">
                            <!-- :label="constantLabel" -->
            </DxConstantLine>
          </DxArgumentAxis>

          <DxValueAxis  :min="valueAxis[0]"
                        :max="valueAxis[1]"
                        :visualRange="valueAxis"
                        visualRangeUpdateMode="keep"
                        :tick-interval="20"
                        overlapping-behavior="none"
                        :label="{ customizeText: formatAsPercent }"
                        position="left">
          </DxValueAxis>

          <DxSeries v-for="(wave, index) in getWaves" :key="index" 
                    :value-field="wave.id"
                    overlapping-behavior="none"
                    :name="wave.label"
                    :color="wave.color" />
  <!-- 
          <DxScrollBar  :visible="scrollBar.enabled"
                        :color="scrollBar.color"
                        :offset="scrollBar.offset"
                        :position="scrollBar.position"
                        :width="scrollBar.width" /> -->

          <!-- <DxZoomAndPan argument-axis="both"/> -->

          <DxLegend :visible="false" 
                    vertical-alignment="bottom"
                    overlapping-behavior="none"
                    horizontal-alignment="right" />
        </DxChart>
      </div>
      <div v-else class="tile-content market-reports-no-data">{{ $t("Webportal.NoData") }}</div>
    </div>

  </div>
</template>

<script>
import MarketReportsMixin from '@/mixins/MarketReportsMixin';
import {
  DxChart, DxSeries, DxCommonSeriesSettings, DxLabel,
  DxFormat, DxLegend, DxArgumentAxis,
  DxValueAxis, DxConstantLine,
  //DxExport, DxScrollBar, DxZoomAndPan
} from 'devextreme-vue/chart';

export default {
  mixins: [MarketReportsMixin],

  components: {
    DxChart, DxSeries, DxCommonSeriesSettings, DxLabel,
    DxFormat, DxLegend, DxArgumentAxis,
    DxValueAxis, DxConstantLine,
    //DxExport, DxScrollBar, DxZoomAndPan
  },

  data() {
    return {
      constantLabel: {
        text: this.$t("Webportal.MarketReports.ProcessQualityOfOptionalModules"),
        font: { color: 'black', weight: 700, size: 11 }
      }
    };
  },

  props: {
    brandMode:  { type: Boolean, required: true },
    data:       { type: Array, required: true },
    waves:      { type: Array, required: true },
  },

  methods: {
    onPointClick({ target }) {
      target.select();
    },
    customizeText({ value }) {
      return this.data.find(x => x.xNumber === value)?.x;
    },
    customizeLabel({ value }) {
      return {
        visible: true,
        backgroundColor: 'none',
        position: Math.round(value) >= 32 ? 'outside' : 'outside',
        font: {
          color: Math.round(value) >= 32 ? 'white' : 'black'
        },
        customizeText: function (x) {
          if (!x || x.value < 0)
            return 'N/A';
          return Math.round(x.value) + '%';
        },
        verticalOffset: Math.round(value) >= 32 ? 44 : 8,
        rotationAngle: -90
      };
    }
  },

  computed: {
    getWaves() {
      if (!this.brandMode)
        return JSON.parse(JSON.stringify(this.waves)).reverse();
      return this.waves;
    },

    constantLinePosition() {
      if(!this.data || !this.data.length) 
        return -1;
      
      // get index of 1st item that has "group" === "Optional Clusters"
      const index = this.data.findIndex(x => x.group === 'Optional Clusters');
      if (index === -1)
        return index;

      return index - 0.5;
    }
  }
}

</script>

<style scoped lang="scss">
#chart {
  height: calc(27vh - 3rem);
}
</style>